<template>
    <el-tabs v-model="activeName" style="padding-left: 8px">
        <el-tab-pane label="邮箱配置" name="first">
            <Config />
        </el-tab-pane>
        <el-tab-pane label="使用说明" name="second">
            <div>
                <blockquote class="my-blockquote">邮件服务器配置</blockquote>
                <pre class="my-code">
# 邮件服务器的SMTP地址，可选，默认为smtp
# 邮件服务器的SMTP端口，可选，默认465或者25
# 发件人（必须正确，否则发送失败）
# 用户名，默认为发件人邮箱前缀
# 密码（注意，某些邮箱需要为SMTP服务单独设置密码，如QQ和163等等）
# 是否开启ssl，默认开启
                </pre>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import Config from './config'
export default {
    name: 'Email',
    components: { Config },
    data() {
        return {
            activeName: 'first'
        }
    }
}
</script>

<style scoped lang="scss">
.my-blockquote {
    margin: 0 0 10px;
    padding: 15px;
    line-height: 22px;
    border-left: 5px solid #00437b;
    border-radius: 0 2px 2px 0;
    background-color: #f2f2f2;
}
.my-code {
    height: 120px;
    position: relative;
    padding: 15px;
    line-height: 20px;
    border-left: 5px solid #ddd;
    color: #333;
    font-family: Courier New, serif;
    font-size: 12px;
}
</style>
